import React from 'react';
import { Typography } from '@waglabs/typography';
import { GetTheAppModal, } from './GetTheAppModal';
import healthTileImageUrl from '../assets/vet-cards.png';
export const HealthTileGetTheAppModal = ({ isPremium, ...props }) => {
    return (React.createElement(GetTheAppModal, Object.assign({ headingText: "The vets are in", subheadingText: (React.createElement(React.Fragment, null,
            "Get help without the in-office vet visit!",
            React.createElement(Typography, { variant: "body2", color: "#FEECB2", lineHeight: "inherit", fontSize: "inherit" }, ` Access ${isPremium ? '$27' : '$30'}  digital pet health consultations `),
            "and more when you download the Wag! mobile app.")), ctaButtonLink: "https://wagwalking.app.link/8FoozI4Nq7", imageUrl: healthTileImageUrl }, props)));
};
